import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { StyleOne, StyleTwo } from '../components/RelatedSCard';
import Jobs from '../data/services.json';
import Not from '../components/NotFound'
import renderHTML from 'react-render-html'
import {CardTwoOutine} from '../components/contentCards/cardTwo';
import asset from '../assets/images/play.jpg'
import { Nav, NavItem, NavLink as ReactStrapNavLink } from 'reactstrap';


class ServiceList extends Component {


    state = {
        // bucket: [],
        Jobs: {
            Jobs: []
        },
        link: this.props.match.params.tabview, //"advisory",
    }


    setActive = (value) => {
        this.setState({ link: value })
      }


    componentDidMount() {
        this.setState({ Jobs })
    }

    render() {

        const { link} = this.state;
        let headText = "";
        let headTitle = "";
        if (link === "advisory"){
          headTitle = 'Advisory';
          headText = "All you need to know in one place";
        }else if (link === "financing"){
          headTitle = 'Financing';
          headText = "We provide bespoke innovative financing solutions to support the growth of business";
        }else if (link === "rManagement"){
          headTitle = 'Risk Management';
          headText = "";
        }else if (link === "cManagement"){
            headTitle = 'Cash Management';
            headText = "";
        }else if (link === "wManagement"){
            headTitle = 'Wealth Management';
            headText = "";
        } else {
            headText = "";  
        }
        return (
            <div className='service-full stockbroking'>
                <header className="banner" style={{backgroundImage: `url(${asset})`, }}>
                    <div className="container-fluid">
                        <div className='paginations'>
                            <div className="gray-button-sm">
                                <Link to='/'>Home</Link>
                            </div>
                            <div className="blue-button-sm">
                                <Link to='/servicelist'>SERVICES</Link>
                            </div>
                        </div>
                        <div className="header-text">
                            <h1 className='bold'>{headTitle}</h1>
                        </div>
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            <p>{headText}</p>
                        </div>
                    </div>
                </header>

                {/* TAB CONTROLS */}
                <div className="resources">
                    <div className="tab-container">
                        {link === "advisory" && <Nav tabs justified>
                            <NavItem onClick={() => { this.setActive("cManagement") }} >
                            <Link to="/servicelist/cManagement">Cash Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("wManagement") }}>
                            <Link to="/servicelist/wManagement">Wealth Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("rManagement") }}>
                            <Link to="/servicelist/rManagement">Risk Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("financing") }} >
                            <Link to="/servicelist/financing">Financing</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("advisory") }}>
                            <Link to="/servicelist/advisory">Advisory</Link>
                            </NavItem>
                        </Nav>}  
                        {link === "financing" && <Nav tabs justified>
                            <NavItem onClick={() => { this.setActive("cManagement") }} >
                            <Link to="/servicelist/cManagement">Cash Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("wManagement") }}>
                            <Link to="/servicelist/wManagement">Wealth Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("rManagement") }}>
                            <Link to="/servicelist/rManagement">Risk Management</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("financing") }} >
                            <Link to="/servicelist/financing">Financing</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("advisory") }}>
                            <Link to="/servicelist/advisory">Advisory</Link>
                            </NavItem>
                        </Nav>}
                        {link === "rManagement" && <Nav tabs justified>
                            <NavItem onClick={() => { this.setActive("cManagement") }} >
                            <Link to="/servicelist/cManagement">Cash Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("wManagement") }}>
                            <Link to="/servicelist/wManagement">Wealth Management</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("rManagement") }}>
                            <Link to="/servicelist/rManagement">Risk Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("financing") }} >
                            <Link to="/servicelist/financing">Financing</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("advisory") }}>
                            <Link to="/servicelist/advisory">Advisory</Link>
                            </NavItem>
                        </Nav>}
                        {link === "cManagement" && <Nav tabs justified>
                            <NavItem active onClick={() => { this.setActive("cManagement") }} >
                            <Link to="/servicelist/cManagement">Cash Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("wManagement") }}>
                            <Link to="/servicelist/wManagement">Wealth Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("rManagement") }}>
                            <Link to="/servicelist/rManagement">Risk Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("financing") }} >
                            <Link to="/servicelist/financing">Financing</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("advisory") }}>
                            <Link to="/servicelist/advisory">Advisory</Link>
                            </NavItem>
                        </Nav>}
                        {link === "wManagement" && <Nav tabs justified>
                            <NavItem onClick={() => { this.setActive("cManagement") }} >
                            <Link to="/servicelist/cManagement">Cash Management</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("wManagement") }}>
                            <Link to="/servicelist/wManagement">Wealth Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("rManagement") }}>
                            <Link to="/servicelist/rManagement">Risk Management</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("financing") }} >
                            <Link to="/servicelist/financing">Financing</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("advisory") }}>
                            <Link to="/servicelist/advisory">Advisory</Link>
                            </NavItem>
                        </Nav>}
                    </div>


                    {/* TAB CONTENTS */}
                    {link === "advisory" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/servicelist/advisory/eCapital' tagName="services" ServiceName="Equity Capital Markets" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/dCapital' tagName="services" ServiceName="Debt Capital Markets" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/fAdvisory' tagName="services" ServiceName="Financing Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/ma' tagName="services" ServiceName="Mergers &amp; Acquisitions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/pFinance' tagName="services" ServiceName="Project Finance" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/sFinance' tagName="services" ServiceName="Structured Finance" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/wPortfolio' tagName="services" ServiceName="Wealth Portfolio Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/advisory/iPortfolio' tagName="services" ServiceName="Institutional Portfolio Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}

                    {link === "financing" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/servicelist/financing/lServices' tagName="services" ServiceName="Lending Services" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/financing/sTrade' tagName="services" ServiceName="Structured Trade Finance" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}

                    {link === "rManagement" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/servicelist/rManagement/fIncome' tagName="services" ServiceName="Fixed Income Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/rManagement/fExchange' tagName="services" ServiceName="Foreign Exchange Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/rManagement/iRate' tagName="services" ServiceName="Interest Rate Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}
                    
                    {link === "cManagement" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/servicelist/cManagement/pReceipts' tagName="services" ServiceName="Processing Receipts" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/cManagement/dSolutions' tagName="services" ServiceName="Digital Solutions &amp; Collections" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/cManagement/tBanking' tagName="services" ServiceName="Transactional Banking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/cManagement/tSales' tagName="services" ServiceName="Treasury Sales" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/cManagement/lManagement' tagName="services" ServiceName="Liquidity Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}

                    {link === "wManagement" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/servicelist/wManagement/wPreservation' tagName="services" ServiceName="Wealth Preservation" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/wManagement/bWealth' tagName="services" ServiceName="Bespoke Wealth Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/wManagement/mFunds' tagName="services" ServiceName="Mutual Funds" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/servicelist/wManagement/sFunds' tagName="services" ServiceName="Segregated Funds" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}
                </div>

                {/* <div className="details"> */}
                    {/* <div className="container-fluid">
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            <p>
                                At FSDH Merchant Bank, we listen to our clients to establish their financial goals,
                                then partner with them to develop bespoke wealth and investment management strategies,
                                as well as identify viable investment opportunities to help preserve and grow their wealth.
                            </p>
                        </div>
                    </div> */}
                    {/* <div className="section-alt home">
                        <div className="container-fluid">
                            <div className="row">
                                <CardTwoOutine nLink='/' tagName="services" ServiceName="Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related services to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="services" ServiceName="Financing" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related services to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="services" ServiceName="Risk Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related services to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="services" ServiceName="Cash Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related services to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="services" ServiceName="Wealth Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related services to non-bank clients for the purpose of investment and risk management." />
                            </div>
                        </div>
                    </div> */}
                {/* </div> */}

                {/* RELATED FEATURES */}
                {/* <div className="section-alt">
                    <div className="container-fluid">
                        <div className="row">
                            <StyleOne tag='services' serviceDesc='Risk Management' bgcolor='dark-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                            <StyleOne tag='services' serviceDesc='Financing' bgcolor='light-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                        </div>
                    </div>
                </div> */}
            </div>
        );
    }
}

export default ServiceList;